"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Units = exports.ThresholdContainer = exports.ThresholdButtonsContainer = exports.StyledContainerWithGraph = exports.StyledContainer = exports.StationDataContainer = exports.SliderWrapper = exports.SelectLabelContainer = exports.Heading = exports.GraphContainer = exports.ErrorMessage = exports.CalendarPageLayout = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../assets/styles/colors");
const Typography_1 = require("../../components/atoms/Typography");
const Navbar_style_1 = require("../../components/molecules/Navbar/Navbar.style");
const media_1 = require("../../utils/media");
const CalendarPageLayout = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  background-color: ${colors_1.gray100};

  @media ${media_1.media.smallDesktop} {
    padding: 0.5rem 1.5rem;
    position: relative;
    top: ${Navbar_style_1.NAVBAR_HEIGHT};
  }
`;
exports.CalendarPageLayout = CalendarPageLayout;
const StationDataContainer = styled_components_1.default.div `
  box-shadow: 0px 5px 20px 2px rgba(0, 0, 0, 0.1);
  width: 100vw;
  max-width: 1600px;
  min-height: 100vh;
  margin: 0;

  @media ${media_1.media.desktop} {
    margin: 20px 5vw;
  }
`;
exports.StationDataContainer = StationDataContainer;
const Heading = (0, styled_components_1.default)(Typography_1.H3) `
  padding-bottom: 2rem;
  font-weight: 600;
  font-size: 22px;

  @media ${media_1.media.smallDesktop} {
    font-size: 28px;
    font-weight: 500;
  }
`;
exports.Heading = Heading;
const Units = styled_components_1.default.sup `
  font-size: 1.4rem;
  vertical-align: super;
  position: relative;
  top: -0.3rem;
  right: -0.2rem;
  font-weight: 400;
  line-height: 1.6;
  margin-left: 0.2rem;
`;
exports.Units = Units;
const StyledContainer = styled_components_1.default.div `
  display: grid;
  grid-template-columns: auto auto 1fr;
  align-items: right;
  grid-gap: 1rem;
  width: 100%;
  justify-items: flex-end;

  @media ${media_1.media.mobile} {
    display: inline;
  }
`;
exports.StyledContainer = StyledContainer;
const StyledContainerWithGraph = (0, styled_components_1.default)(StyledContainer) `
  grid-template-columns: auto 2fr 1fr;
`;
exports.StyledContainerWithGraph = StyledContainerWithGraph;
const ThresholdContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-bottom: 3rem;
  background-color: ${colors_1.white};

  @media ${media_1.media.desktop} {
    padding: 3rem 10rem;
    margin-bottom: 0;
  }

  @media ${media_1.media.largeDesktop} {
    padding: 3rem 10rem;
    margin-bottom: 0;
  }
  ${(props) => props.$isMobile && `padding: 1.5rem; gap: 2rem;`}
`;
exports.ThresholdContainer = ThresholdContainer;
const ThresholdButtonsContainer = styled_components_1.default.div `
  display: grid;
  justify-content: space-between;
  align-items: center;
  gap: 2.4rem;
  min-width: 4.4rem;
  grid-template-columns: repeat(2, 1fr);
`;
exports.ThresholdButtonsContainer = ThresholdButtonsContainer;
const ErrorMessage = styled_components_1.default.p `
  color: ${colors_1.red100};
  position: absolute;
  background-color: ${colors_1.white};
  top: 8%;
  left: 50%;
  transform: translate(-50%, -40%);
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  z-index: 20;

  @media ${media_1.media.smallDesktop} {
    font-size: 1.5rem;
    transform: translate(-50%, -50%);
    top: 30%;
  }
`;
exports.ErrorMessage = ErrorMessage;
const SliderWrapper = styled_components_1.default.div `
  display: flex;
  @media ${media_1.media.desktop} {
    margin-top: 4rem;
  }
`;
exports.SliderWrapper = SliderWrapper;
const GraphContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-bottom: 3rem;
  background-color: ${colors_1.white};

  @media ${media_1.media.desktop} {
    padding: 3rem 10rem;
    margin-bottom: 0;
  }

  @media ${media_1.media.largeDesktop} {
    padding: 3rem 10rem;
    margin-bottom: 0;
  }

  ${(props) => props.$isMobile && `padding: 1.5rem; gap: 2rem;`}
`;
exports.GraphContainer = GraphContainer;
const SelectLabelContainer = styled_components_1.default.span `
  display: flex;
  position: absolute;
  top: 6rem;
  font-size: 1.6rem;
  color: ${colors_1.gray400};
`;
exports.SelectLabelContainer = SelectLabelContainer;
